import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
export function ProblemSection() {
  const problems = ['Rutinas de YouTube que no encajan con tu vida', 'Dietas de otro país con ingredientes imposibles', 'Empezás el lunes y abandonás el miércoles', 'El fin de semana tira abajo todo lo de la semana', 'Siempre volvés al punto de partida con más culpa', 'El "el lunes empiezo" que nunca llega de verdad'];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto" data-id="element-184">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} className="text-center mb-12" data-id="element-185">
        <h2 className="text-4xl md:text-5xl font-black mb-6 leading-tight" data-id="element-186">
          ¿Cuántos lunes más vas a empezar de cero?
        </h2>
        <p className="text-xl text-gray-300" data-id="element-187">
          Querés bajar la panza. Pero cada vez que intentás algo aparece el
          mismo ciclo:
        </p>
      </motion.div>

      <div className="space-y-4 mb-16" data-id="element-188">
        {problems.map((problem, i) => <motion.div key={i} initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.1
      }} className="bg-brand-card border border-red-900/30 rounded-xl p-5 flex items-center gap-4" data-id="element-189">
            <div className="bg-red-500/10 p-2 rounded-full shrink-0" data-id="element-190">
              <X className="w-5 h-5 text-red-500" data-id="element-191" />
            </div>
            <p className="text-gray-200 font-medium text-lg" data-id="element-192">{problem}</p>
          </motion.div>)}
      </div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="text-center" data-id="element-193">
        <h3 className="text-3xl md:text-4xl font-black text-brand-green" data-id="element-194">
          No es falta de voluntad.
          <br data-id="element-195" />
          Es falta de un sistema.
        </h3>
      </motion.div>
    </section>;
}